import store           from '../configureStore';
import { Permissions } from '../reducer/user';
import { isAdminUser } from '../shared/utils/permissions';


export enum CrudIndex {
  CREATE,
  READ,
  UPDATE,
  DELETE,
}

type CheckCrudPermissionsAlias = (entityId: string) => boolean;

export const checkCrudPermissionsDirectly = (operationType: CrudIndex, entityId: string, permissions: Permissions, userId: number | undefined): boolean => {
  if (userId && isAdminUser(userId)) {
    return true;
  }

  let permissionsCode = permissions[entityId];

  if (entityId === '/map' && operationType === CrudIndex.READ) {
    if (permissions['/map/currentData'] &&
        !!+permissions['/map/currentData'].toString(2)
                                         .padStart(4, '0')[operationType]) {
      permissionsCode = permissions['/map/currentData'];
    } else {
      permissionsCode = permissions['/map/previousData'];
    }
  } else if (entityId === '/handbooks/table/:handbookType') {
    const permissionsEntityId = Object
      .keys(permissions)
      .find((_entityId) => _entityId.includes('/handbooks/table/'));

    if (permissionsEntityId) {
      permissionsCode = permissions[permissionsEntityId];
    }
  } else if (entityId.includes('/video/online/live/')) {
    permissionsCode = permissions['/video/online'];
  }

  if (!permissionsCode) {
    const permissionsEntityId = Object
      .keys(permissions)
      .find((_entityId) => {
              const base  = entityId
                .split('/')
                .filter((i) => i.trim() !== '')[0];

        return _entityId === base || _entityId === `/${base}`;
      });

    if (permissionsEntityId) {
      permissionsCode = permissions[permissionsEntityId];
    }
  }

  if (!permissionsCode) {
    return false;
  }

  const permissionsSequence = permissionsCode.toString(2).padStart(4, '0');

  return !!+permissionsSequence[operationType];
}

export const checkCrudPermissions = (operationType: CrudIndex, entityId: string): boolean =>
  checkCrudPermissionsDirectly(operationType, entityId, store.getState().user.permissions, store.getState().user.userId);

export const checkCreate: CheckCrudPermissionsAlias = (entityId) =>
  checkCrudPermissions(CrudIndex.CREATE, entityId);

export const checkRead: CheckCrudPermissionsAlias = (entityId) =>
  checkCrudPermissions(CrudIndex.READ, entityId);

export const checkUpdate: CheckCrudPermissionsAlias = (entityId) =>
  checkCrudPermissions(CrudIndex.UPDATE, entityId);

export const checkDelete: CheckCrudPermissionsAlias = (entityId) =>
  checkCrudPermissions(CrudIndex.DELETE, entityId);